import React, { useCallback } from 'react';
import { EntityTypeType, UserRoleType } from '~/components/Admin';
import { AdminServiceEvents, ServicesContext } from '~/services';

export interface NewUserRolesType {
    tin?: { id: number };
    tin_roles?: string[]; // eslint-disable-line babel/camelcase
    macl?: { id: number };
    macl_roles?: string[]; // eslint-disable-line babel/camelcase
    market?: { id: number };
    market_roles?: string[]; // eslint-disable-line babel/camelcase
    markets?: { id: number }[];
}
export interface AddUserRolesType extends NewUserRolesType {
    user: { id: number };
}
export const useAddUserRoles = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const addUserRoles = useCallback(
        async (data: AddUserRolesType[], entityType: EntityTypeType) => {
            const response = await services.api.call({
                method: 'post',
                url: `/api/${entityType}-users`,
                data,
            });
            services.events.publish(
                events[`user_${entityType}_added`],
                response.data['hydra:member']
            );
            const result: UserRoleType[] = response.data['hydra:member'];
            return result;
        },
        [services.api, services.events, events]
    );

    return addUserRoles;
};
